const resources = {
    textUs: 'Text Us',
    agreeText: 'By texting us, you agree to Sephora’s',
    textTerms: 'TEXT TERMS',
    and: 'and',
    privacyPolicy: 'Privacy Policy',
    disclaimer: '. Messages & data rates may apply. Messages frequency varies. Reply STOP to opt out or HELP for help. The number you will hear from Sephora is ',
    representative: 'Representatives are available:',
    monFri: 'MON-FRI',
    monFriTime: '5am - 9pm PT',
    satSun: 'SAT-SUN',
    satSunTime: '6am - 9pm PT'
};

export default function getResource(label) {
    return resources[label];
}
